import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const sportRoute = createMetaRoute<RouteMeta>();

export const sportEventRoute = createMetaRoute<RouteMeta, { id: string }>({
    key: (params) => params.id,
});
